import React, { useEffect, useRef, useState } from 'react';
import { Chart } from 'chart.js';

const StateChart = ({ data }) => {
    const canvasRef = useRef(null);
    const [chartData, setChartData] = useState({
        labels: [],
        counts: [],
    });

    const options = {
        type: 'bar', // Change to 'bar' if you want a bar chart; otherwise, keep it as 'line'
        data: {
            labels: [], // This will be populated dynamically
            datasets: [
                {
                    label: 'Collaboration Count',
                    fill: false,
                    borderColor: "#4caf50",
                    backgroundColor: "#4caf5040",
                    data: [], // This will be populated dynamically
                },
            ],
        },
    };

    useEffect(() => {
        if (data) {
            const labels = data.map(item => item.state);
            const counts = data.map(item => item.collaborationCount);

            setChartData({ labels, counts });
        }
    }, [data]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        // Initialize the chart
        const chart = new Chart(ctx, {
            ...options,
            data: {
                ...options.data,
                labels: chartData.labels,
                datasets: [
                    {
                        ...options.data.datasets[0],
                        data: chartData.counts,
                    },
                ],
            },
        });

        // Cleanup the chart instance when the component unmounts
        return () => {
            chart.destroy();
        };
    }, [chartData]); // Run whenever chartData changes

    return (
        <div>
            <canvas ref={canvasRef} />
        </div>
    );
};

export default StateChart;
